const tkbTooltip = {
  en: {
    TKB0: "Angka pada TKB0 menampilkan ukuran tingkat keberhasilan Penyelenggara dalam memfasilitasi penyelesaian kewajiban Pendanaan dalam jangka waktu sampai dengan 14 hari kalender terhitung sejak jatuh tempo",
    TKB30:
      "TKB30 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 30 hari terhitung sejak jatuh tempo.",
    TKB60:
      "TKB60 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 60 hari terhitung sejak jatuh tempo.",
    TKB90:
      "TKB90 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 90 hari terhitung sejak jatuh tempo.",
  },
  id: {
    TKB0: "Angka pada TKB0 menampilkan ukuran tingkat keberhasilan Penyelenggara dalam memfasilitasi penyelesaian kewajiban Pendanaan dalam jangka waktu sampai dengan 14 hari kalender terhitung sejak jatuh tempo",
    TKB30:
      "TKB30 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 30 hari terhitung sejak jatuh tempo.",
    TKB60:
      "TKB60 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 60 hari terhitung sejak jatuh tempo.",
    TKB90:
      "TKB90 adalah tingkat keberhasilan OVO Finansial dalam memfasilitasi penyelesaian kewajiban pinjam meminjam dalam jangka waktu sampai dengan 90 hari terhitung sejak jatuh tempo.",
  },
};

export { tkbTooltip };
